import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "group toast glass-surface glass-surface--strong rounded-xl text-foreground border border-border/65 shadow-xl",
          title: "group-[.toast]:!text-foreground group-[.toast]:font-medium",
          description: "group-[.toast]:!text-muted-foreground",
          actionButton:
            "group-[.toast]:rounded-full group-[.toast]:border group-[.toast]:border-primary/45 group-[.toast]:bg-primary/85 group-[.toast]:text-primary-foreground group-[.toast]:shadow-[inset_0_1px_0_rgba(255,255,255,0.3)]",
          cancelButton:
            "group-[.toast]:rounded-full group-[.toast]:border group-[.toast]:border-border/70 group-[.toast]:bg-card/72 group-[.toast]:text-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
